import React from 'react';
import PropTypes from 'prop-types';
import CrumbName from './CrumbName';
import {SVGIcon} from '@homeaway/react-svg';
import {CHEVRON_RIGHT__12} from '@homeaway/svg-defs/lib/defs/CHEVRON_RIGHT__12';

const LinkedCrumb = ({
    currentPage,
    hasDivider,
    onClickName,
    name,
    position,
    url
}) => {
    const ariaCurrent = (currentPage) ? 'page' : '';

    return (
    <li className="Breadcrumb__li" itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
        <a href={url} aria-current={ariaCurrent} className="Breadcrumb__a" title={name} itemProp="item">
            <CrumbName name={name} onClick={onClickName}/>
            <span itemProp="position" content={position} aria-hidden/>
        </a>
        {hasDivider && <SVGIcon markup={CHEVRON_RIGHT__12} inlineFlex className="Breadcrumb__divider" aria-hidden/>}
    </li>
    );
};

LinkedCrumb.propTypes = {
    currentPage: PropTypes.bool,
    hasDivider: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onClickName: PropTypes.func.isRequired,
    position: PropTypes.number.isRequired,
    url: PropTypes.string.isRequired
};

export default LinkedCrumb;
